import React, { useEffect } from 'react';
import { useLazyFetchUserProfileQuery } from 'src/store/userApi';
import { Spinner } from 'src/ui/Spinner';
import UserProfileDisplay from '../match-test/userProfileDisplay';

interface MatchedUserProfileProps {
  userId?: string;
  matchedUser?: {
    id: string;
    name?: string;
    email: string;
  };
}

const MatchedUserProfile = ({
  userId,
  matchedUser,
}: MatchedUserProfileProps) => {
  const [fetchUserProfile, { data: userProfile, isLoading }] =
    useLazyFetchUserProfileQuery();

  useEffect(() => {
    if (userId) {
      fetchUserProfile(userId);
    }
  }, [userId, fetchUserProfile]);

  if (!userId || !matchedUser) {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            padding: 16,
            borderBottom: '1px solid var(--border)',
            flexShrink: 0,
          }}
        >
          <span
            style={{
              fontWeight: 600,
              color: 'var(--text-muted)',
              fontSize: 'var(--fs-sm)',
            }}
          >
            Matched User Profile
          </span>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span
            style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-sm)' }}
          >
            Select a match to view profile
          </span>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            padding: 16,
            borderBottom: '1px solid var(--border)',
            flexShrink: 0,
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 'var(--fs-sm)' }}>
            Matched User Profile
          </span>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner size="lg" />
        </div>
      </div>
    );
  }

  return (
    <UserProfileDisplay
      user={userProfile || null}
      title="Matched User Profile"
    />
  );
};

export default MatchedUserProfile;
